import React from 'react';
import I18n from '../../config/locales';
const SecurePrivacyButton = () =>{
    let securePrivacyEnabled = false
    try{
        if(JSON.parse(localStorage.getItem('is_secure_privacy_enabled'))){
            securePrivacyEnabled = true
        }
    }
    catch(e) {
        securePrivacyEnabled = false;
    }

    return (securePrivacyEnabled && <div className="sp-privacy-container">
        <span id="sp-tb-embed-widget" className="sp-tb-embed-btn secure-privacy-tag"
        onClick={()=>window.sp.showPrivacyBanner()}>{I18n.t('buttons.privacyBanner')}</span>
    </div>  )
}

export default SecurePrivacyButton